import { Button, Toolbar } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import QuoteBarcode from "../../components/Quote/QuoteBarcode";
import { baseUrl } from "../../Config";
import Color from "../../enum/Color";
import LanguageEnum from "../../enum/LanguageEnum";
import PaymentMethodENGEnum from "../../enum/PaymentMethodENGEnum";
import PaymentMethodEnum from "../../enum/PaymentMethodEnum";
import UnitENGEnum from "../../enum/UnitENGEnum";
import UnitEnum from "../../enum/UnitEnum";
import Logo from "../../imgs/logo.svg";
import AuthContext from "../../store/auth-context";
import useApiRequest from "../../store/use-http";
import { formatDate, formatPrice, isNull } from "../../utils/Utils";
import "./QuotePreview.css";
import generatePDF, { Resolution, Margin } from "react-to-pdf";

const QuotePreview = () => {
  const companyInfo = JSON.parse(sessionStorage.getItem("companyInfo"));
  const params = useParams();

  const [quote, setQuote] = useState(null);
  const [status, setStatus] = useState(null);

  const authContext = useContext(AuthContext);

  const url = baseUrl + "/api/quote?id=" + params.quoteId;

  const { data} = useApiRequest(
    url,
    "GET",
    authContext.token
  );

  useEffect(() => {
    setQuote(data);
    setStatus(data.status);
  }, [data]);

  const downloadPDF = () => {
    const options = {
      filename: !isNull(quote) &&
      (LanguageEnum[quote.customer.language] === LanguageEnum.ENG
        ? "Quote no."
        : "Ponuda br.") + quote.quoteeNumber,
      method: "save",
      // default is Resolution.MEDIUM = 3, which should be enough, higher values
      // increases the image quality but also the size of the PDF, so be careful
      // using values higher than 10 when having multiple pages generated, it
      // might cause the page to crash or hang.
      resolution: Resolution.EXTREME,
      page: {
        // margin is in MM, default is Margin.NONE = 0
        margin: Margin.SMALL,
        // default is 'A4'
        format: "A4",
        // default is 'portrait'
        orientation: "portrait"
      },
      canvas: {
        // default is 'image/jpeg' for better size performance
        mimeType: "image/jpeg",
        qualityRatio: 1
      },
      // Customize any value passed to the jsPDF instance and html2canvas
      // function. You probably will not need this and things can break,
      // so use with caution.
      overrides: {
        // see https://artskydj.github.io/jsPDF/docs/jsPDF.html for more options
        pdf: {
          compress: false
        },
        // see https://html2canvas.hertzen.com/configuration for more options
        canvas: {
          useCORS: true
        }
      }
    };
    const getTargetElement = () => document.getElementById("invoice");
    generatePDF(getTargetElement, options);
  }

  return (
    <div style={{ backgroundColor: Color.ACCENT1 }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Toolbar
          style={{
            display: "flex",
            gap: "1rem",
            justifyContent: "center",
            backgroundColor: Color.ACCENT2,
          }}
        >
          <Button
            variant="contained"
            onClick={downloadPDF}
          >
            Confirm and download
          </Button>
        </Toolbar>
      </div>
      <div className="invoicePage" id="invoice">
        <div
          className="details-container clearfix invoicePage"
          style={{ margiLeft: "auto", margiRight: "auto" }}
        >
          <div className="pcs-template flex">
            <div>
              <div className="pcs-template-body">
                <table
                  className="invoiceTable"
                  style={{ width: "100%", tableLayout: "fixed" }}
                >
                  <tbody>
                    <tr>
                      <td style={{ verticalAlign: "top", width: "50%" }}>
                        <div>
                          <img
                            src={Logo}
                            alt="Logo"
                            id="logo_content"
                          />
                        </div>
                        <span className="pcs-orgname">
                          <b>{companyInfo.companyName}</b>
                        </span>
                        <br />
                        <span className="pcs-label">
                          <span id="tmp_org_address" className="preWrap">
                            {companyInfo.address}
                          </span>
                          <br />
                          <span>
                            {companyInfo.zipCode}, {companyInfo.city}
                          </span>{" "}
                          <br />
                          <span>{companyInfo.country}</span> <br />
                          <span>OIB: {companyInfo.businessId}</span> <br />
                          <span>IBAN: {companyInfo.iban}</span> <br />
                          
                          {!isNull(quote) && LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG &&
                              <span>SWIFT: {companyInfo.swift}</span>
                          }
                          {!isNull(quote) && LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG &&
                              <br />
                          }
                        
                          <span>
                            {!isNull(quote) &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "VAT ID: "
                                : "PDV ID: ")}{" "}
                            {companyInfo.pdvId}
                          </span>
                        </span>
                      </td>
                      <td
                        style={{ width: "50%" }}
                        className="text-align-right v-top"
                      >
                        <span className="pcs-entity-title">
                          {!isNull(quote) &&
                            (LanguageEnum[quote.customer.language] ===
                            LanguageEnum.ENG
                              ? "QUOTE"
                              : "PONUDA")}
                        </span>
                        <br />
                        <span
                          id="tmp_entity_number"
                          style={{ fontSize: "10pt" }}
                          className="pcs-label"
                        >
                          <b>
                            {!isNull(quote) &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "Quote no. "
                                : "Ponuda br. ")}{" "}
                            {quote && quote.quoteNumber}
                          </b>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  className="invoiceTable"
                  style={{
                    clear: "both",
                    width: "100%",
                    marginTop: "30px",
                    tableLayout: "fixed",
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        style={{
                          width: "60%",
                          verticalAlign: "bottom",
                          wordWrap: "break-word",
                        }}
                      >
                        <div className="billto-section">
                          <label
                            style={{ fontSize: "10pt" }}
                            className="pcs-label"
                            id="tmp_billing_address_label"
                          >
                            {!isNull(quote) &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "Customer "
                                : "Naručitelj ")}
                          </label>
                          <br />
                          <span className="preWrap" id="tmp_billing_address">
                            <strong>
                              <span
                                className="pcs-customer-name"
                                id="zb-pdf-customer-detail"
                              >
                                {quote &&
                                  quote.customer &&
                                  quote.customer.companyDisplayName}
                              </span>
                            </strong>
                            <br />
                            <span>
                              {quote &&
                                quote.customer &&
                                quote.customer.address}
                            </span>
                            <br />
                            <span>
                              {quote &&
                                quote.customer &&
                                quote.customer.zipCode +
                                  ", " +
                                  quote.customer.city}
                            </span>
                            <br />
                            <span>
                              {quote &&
                                quote.customer &&
                                quote.customer.country}
                            </span>
                            <br />
                            <span>
                              OIB:{" "}
                              {quote &&
                                quote.customer &&
                                quote.customer.businessId}
                            </span>
                            <br />
                            {quote &&
                              quote.customer &&
                              quote.customer.pdvId &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "VAT ID: "
                                : "PDV ID: ") + quote.customer.pdvId}
                          </span>
                        </div>
                      </td>
                      <td
                        align="right"
                        style={{ verticalAlign: "bottom", width: "40%" }}
                      >
                        <table
                          className="invoiceTable"
                          style={{
                            float: "right",
                            width: "100%",
                            tableLayout: "fixed",
                            wordWrap: "break-word",
                          }}
                          border="0"
                          cellSpacing="0"
                          cellPadding="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span className="pcs-label">
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Quote date: "
                                      : "Datum izdavanja: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_entity_date">
                                  {!isNull(quote) &&
                                    formatDate(quote.quoteDate)}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span className="pcs-label">
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Due date: "
                                      : "Datum dospijeća: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_due_date">
                                  {!isNull(quote) &&
                                    formatDate(quote.dueDate)}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span className="pcs-label">
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Seller: "
                                      : "Ponudu izdao: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_salesperson_name">
                                  {!isNull(quote) && quote.seller}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td></td>
                            </tr>

                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span
                                  className="pcs-label"
                                  id="tmp_entity_cflabel"
                                >
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Delivery date: "
                                      : "Datum isporuke: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_entity_cfvalue">
                                  {!isNull(quote) &&
                                    formatDate(quote.deliveryDate)}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span
                                  className="pcs-label"
                                  id="tmp_entity_cflabel"
                                >
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Quote time: "
                                      : "Vrijeme izdavanja: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_entity_cfvalue">
                                  {!isNull(quote) && quote.quoteTime}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  padding: "5px 10px 5px 0px",
                                  fontSize: "10pt",
                                }}
                                className="text-align-right"
                              >
                                <span
                                  className="pcs-label"
                                  id="tmp_entity_cflabel"
                                >
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? "Payment method: "
                                      : "Način plaćanja: ")}
                                </span>
                              </td>
                              <td className="text-align-right">
                                <span id="tmp_entity_cfvalue">
                                  {!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG
                                      ? PaymentMethodENGEnum[
                                        quote.paymentMethod
                                        ]
                                      : PaymentMethodEnum[
                                        quote.paymentMethod
                                        ])}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    tableLayout: "fixed",
                  }}
                  className="pcs-itemtable invoiceTable"
                  border="0"
                  cellSpacing="0"
                  cellPadding="0"
                >
                  <thead>
                    <tr style={{ height: "32px" }}>
                      <td
                        style={{
                          padding: "5px 0px 5px 5px",
                          width: "5%",
                          textAlign: "center",
                        }}
                        id=""
                        className="pcs-itemtable-header pcs-itemtable-breakword"
                      >
                        #
                      </td>
                      <td
                        style={{
                          padding: "5px 10px 5px 20px",
                          width: "",
                          textAlign: "left",
                        }}
                        id=""
                        className="pcs-itemtable-header pcs-itemtable-breakword"
                      >
                        {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Item & description "
                            : "Stavka i opis ")}
                      </td>
                      <td
                        style={{
                          padding: "5px 10px 5px 5px",
                          width: "15%",
                          textAlign: "right",
                        }}
                        id=""
                        className="pcs-itemtable-header pcs-itemtable-breakword"
                      >
                        {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Qty. "
                            : "Kol. ")}
                      </td>
                      <td
                        style={{
                          padding: "5px 10px 5px 5px",
                          width: "15%",
                          textAlign: "right",
                        }}
                        id=""
                        className="pcs-itemtable-header pcs-itemtable-breakword"
                      >
                        {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Price "
                            : "Cijena ")}
                        (EUR)
                      </td>
                      {companyInfo.displayEuro === true && (
                        <td
                          style={{
                            padding: "5px 10px 5px 5px",
                            width: "10%",
                            textAlign: "right",
                          }}
                          id=""
                          className="pcs-itemtable-header pcs-itemtable-breakword"
                        >
                          {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Price "
                            : "Cijena ")}
                        (HRK)
                        </td>
                      )}
                      <td
                        style={{
                          padding: "5px 10px 5px 5px",
                          width: "15%",
                          textAlign: "right",
                        }}
                        id=""
                        className="pcs-itemtable-header pcs-itemtable-breakword"
                      >
                        {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Total "
                            : "Ukupno ")}{" "}
                        (EUR)
                      </td>
                      {companyInfo.displayEuro === true && (
                        <td
                          style={{
                            padding: "5px 10px 5px 5px",
                            width: "10%",
                            textAlign: "right",
                          }}
                          id=""
                          className="pcs-itemtable-header pcs-itemtable-breakword"
                        >
                          {!isNull(quote) &&
                          (LanguageEnum[quote.customer.language] ===
                          LanguageEnum.ENG
                            ? "Total "
                            : "Ukupno ")}{" "}
                          (HRK)
                        </td>
                      )}
                    </tr>
                  </thead>
                  <tbody className="itemBody">
                    {quote &&
                      quote.quoteItems &&
                      quote.quoteItems.map((item, index) => {
                        return (
                          <tr className="breakrow-inside breakrow-after">
                            <td
                              rowSpan="1"
                              valign="top"
                              style={{
                                padding: "10px 0 10px 5px",
                                textAlign: "center",
                                wordWrap: "break-word",
                              }}
                              className="pcs-item-row"
                            >
                              {index + 1}
                            </td>
                            <td
                              rowSpan="1"
                              valign="top"
                              style={{ padding: "10px 0px 10px 20px" }}
                              className="pcs-item-row"
                            >
                              <div>
                                <div>
                                  <span
                                    style={{ wordWrap: "break-word" }}
                                    id="tmp_item_name"
                                  >
                                    {item.itemName}
                                  </span>
                                  <br />

                                  <span
                                    style={{
                                      whiteSpace: "pre-wrap",
                                      wordWrap: "break-word",
                                    }}
                                    className="pcs-item-desc"
                                    id="tmp_item_description"
                                  >
                                    {item.description}
                                  </span>
                                </div>
                              </div>
                            </td>

                            <td
                              rowSpan="1"
                              className="pcs-item-row lineitem-column text-align-right"
                              style={{
                                padding: "5px 10px 5px 5px",
                                width: "10%",
                                textAlign: "right",
                              }}
                            >
                              <span id="tmp_item_qty">
                                {formatPrice(item.quantity)}{" "}
                                {!isNull(quote) &&
                                (LanguageEnum[quote.customer.language] ===
                                LanguageEnum.ENG
                                  ? UnitENGEnum[item.unit]
                                  : UnitEnum[item.unit])}
                              </span>
                            </td>
                            <td
                              rowSpan="1"
                              className="pcs-item-row lineitem-column text-align-right"
                              style={{
                                padding: "5px 10px 5px 5px",
                                width: "10%",
                                textAlign: "right",
                              }}
                            >
                              <span id="tmp_item_rate">
                                {formatPrice(item.price)}
                              </span>
                            </td>
                            {companyInfo.displayEuro === true && (
                              <td
                                rowSpan="1"
                                className="pcs-item-row lineitem-column text-align-right"
                                style={{
                                  padding: "5px 10px 5px 5px",
                                  width: "10%",
                                  textAlign: "right",
                                }}
                              >
                                <span id="tmp_item_rate">
                                  {formatPrice(item.priceHrk)}
                                </span>
                              </td>
                            )}
                            <td
                              rowSpan="1"
                              className="pcs-item-row lineitem-column lineitem-content-right text-align-right"
                              style={{
                                padding: "5px 10px 5px 5px",
                                width: "10%",
                                textAlign: "right",
                              }}
                            >
                              <span id="tmp_item_amount">
                                {formatPrice(item.totalItemCurrency)}
                              </span>
                            </td>
                            {companyInfo.displayEuro === true && (
                              <td
                                rowSpan="1"
                                className="pcs-item-row lineitem-column lineitem-content-right text-align-right"
                                style={{
                                  padding: "5px 10px 5px 5px",
                                  width: "10%",
                                  textAlign: "right",
                                }}
                              >
                                <span id="tmp_item_amount">
                                  {formatPrice(item.totalHrk)}
                                </span>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <div style={{ width: "50%", marginTop: "1px", float: "right" }}>
                  <div className="v-top total-number-section">
                    <div style={{ whiteSpace: "pre-wrap" }}></div>
                  </div>
                  <div className="v-top total-section">
                    <table
                      className="pcs-totals invoiceTable"
                      cellSpacing="0"
                      border="0"
                      width="100%"
                    >
                      <tbody>
                        <tr>
                          <td className="total-section-label text-align-right">
                            {!isNull(quote) &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "Subtotal "
                                : "Vrijednost podzbroja ")}
                          </td>
                          <td
                            id="tmp_subtotal"
                            className="total-section-value text-align-right"
                          >
                            {!isNull(quote) && formatPrice(quote.subtotal)}{" "}
                            EUR
                            <br />
                            {companyInfo.displayEuro === true && (
                              <span>
                                {!isNull(quote) &&
                                  formatPrice(quote.subtotalHrk)}{" "}
                                HRK
                              </span>
                            )}
                          </td>
                        </tr>

                        {!isNull(quote) && quote.totalTax > 0 &&
                          <tr>
                          <td className="total-section-label text-align-right">
                          {!isNull(quote) &&
                              (LanguageEnum[quote.customer.language] ===
                              LanguageEnum.ENG
                                ? "VAT (25%) "
                                : "PDV (25%) ")}
                          </td>
                          <td
                            id="tmp_subtotal"
                            className="total-section-value text-align-right"
                          >
                            {!isNull(quote) && formatPrice(quote.totalTax)}{" "}
                            EUR
                            <br />
                            {companyInfo.displayEuro === true && (
                              <span>
                                {!isNull(quote) &&
                                  formatPrice(quote.totalTaxHrk)}{" "}
                                HRK
                              </span>
                            )}
                          </td>
                        </tr>
                        }

                        <tr style={{ height: "40px" }} className="pcs-balance">
                          <td className="total-section-label text-align-right">
                            <b>
                              {!isNull(quote) &&
                                (LanguageEnum[quote.customer.language] ===
                                LanguageEnum.ENG
                                  ? "Total "
                                  : "Ukupno ")}
                            </b>
                          </td>
                          <td
                            id="tmp_total"
                            className="total-section-value text-align-right"
                          >
                            <b>
                              {!isNull(quote) && formatPrice(quote.total)}{" "}
                              EUR
                              <br />
                              {companyInfo.displayEuro === true && (
                                <span>
                                  {!isNull(quote) &&
                                    formatPrice(quote.totalHrk)}{" "}
                                  HRK
                                </span>
                              )}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>
                <tr style={{ height: "40px", width: "100%" }}>
                  <td
                    id="tmp_total"
                    className="total-section-value text-align-right"
                    style={{ width: "100%" }}
                  >
                    <b>{!isNull(quote) &&
                                    (LanguageEnum[quote.customer.language] ===
                                    LanguageEnum.ENG)
                                      ? "Scan to pay code"
                                      : "Kod za uplatu"}</b>
                    {!isNull(quote) && <QuoteBarcode quote={quote} />}
                  </td>
                </tr>
                <div
                  style={{ clear: "both", marginTop: "50px", width: "100%" }}
                >
                  <label
                    style={{ fontSize: "10pt" }}
                    id="tmp_notes_label"
                    className="pcs-label"
                  >
                    {!isNull(quote) &&
                      (LanguageEnum[quote.customer.language] ===
                      LanguageEnum.ENG
                        ? "Note "
                        : "Napomene ")}
                  </label>
                  <br />
                  <p
                    style={{
                      marginTop: "7px",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                    className="pcs-notes"
                  >
                    {!isNull(quote) && quote.note}
                  </p>
                </div>

                <div
                  style={{ clear: "both", marginTop: "30px", width: "100%" }}
                >
                  <label
                    style={{ fontSize: "10pt" }}
                    id="tmp_terms_label"
                    className="pcs-label"
                  >
                    {!isNull(quote) &&
                      (LanguageEnum[quote.customer.language] ===
                      LanguageEnum.ENG
                        ? "Terms & Conditions "
                        : "Uvjeti i odredbe ")}
                  </label>
                  <br />
                  <p
                    style={{
                      marginTop: "7px",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                    className="pcs-terms"
                  >
                    {!isNull(quote) && quote.termsAndConditions}
                  </p>
                </div>

                <div style={{ pageBreakInside: "avoid" }}></div>
              </div>
            </div>

            <div className="pcs-template-footer">
              <div className="pcs-footer-content">
                <div style={{ textAlign: "center" }}>
                  <font size="1">
                    Portobyte d.o.o. za računalne djelatnosti∣ Garešnička 24 ∣
                    10040, Zagreb ∣ OIB 3374060098∣
                    HR2324020061101074647&nbsp;Erste banka d.d. Zagreb ∣
                    Temeljni kapital 20.000,00 kn (uplaćen u cijelosti) ∣&nbsp;
                  </font>
                  <span style={{ fontSize: "x-small" }}>
                    Trgovački sud Zagreb reg. broj Tt-22/5411-2∣ Direktor:
                    Kristijan Zdelarec
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotePreview;
